import { useQuery } from '@tanstack/react-query';
import { apiService } from '../../services/api';
import { queryKeys } from './queryKeys';

export function useEvents(
  leagueTypeId: string | undefined,
  status?: 'upcoming' | 'in_progress' | 'completed' | 'cancelled'
) {
  return useQuery({
    queryKey: queryKeys.events(leagueTypeId ?? '', status ?? 'all'),
    queryFn: () => apiService.getEvents(leagueTypeId!, status),
    staleTime: 5 * 60 * 1000,
    enabled: !!leagueTypeId,
    select: (data) => data.events,
  });
}
